export default function () {
  return {
    name: [
      {
        required: true,
        message: '请输入定向名称',
        trigger: 'blur'
      },
      {
        max: 20,
        message: '最多20个字符',
        trigger: 'blur'
      }
    ],
    siteSet: [
      {
        validator: (rule, value, callback) => {
          if (!value?.length) {
            return callback(new Error('请选择版位'))
          }
          callback()
        },
        trigger: 'change'
      }
    ],
    priority_site_set: [
      {
        validator: (rule, value, callback) => {
          if (!value?.length) {
            return callback(new Error('请选择优选版位'))
          }
          callback()
        },
        trigger: 'change'
      }
    ],
    regionType: [
      {
        validator: (rule, value, callback) => {
          if (value === 1) {
            if (!this.targetingForm.region?.length) return callback(new Error('请选择地域'))
            if (!this.targetingForm.locationTypes?.length) return callback(new Error('请至少选择一种类型'))
          }
          callback()
        },
        trigger: 'change'
      }
    ],

    deviceType: [
      {
        validator: (rule, value, callback) => {
          if (value === 1) {
            if (!this.targetingForm.device?.length) callback(new Error('请选择手机品牌'))
          }
          callback()
        },
        trigger: 'change'
      }
    ],

    osType: {
      validator: (rule, value, callback) => {
        if (value === 1) {
          if (!this.targetingForm.version?.length) callback(new Error('请选择系统版本'))
        }
        callback()
      },
      trigger: 'change'
    }
  }
}
